
// SMS "text us" support widget — the fake-live-chat launcher that actually
// routes to SMS. Ported from pl-www (components/app/supportChat.vue) for Vue 2 /
// Vuetify (scoped CSS, inline SVG, no Tailwind). Replaces the tawk.to widget.
// Events fire through the global pls_app_track mixin → GA4 (gtag) + Clarity.
export default {
  name: 'SupportChat',
  data() {
    return {
      phoneDisplay: '(855) 670-0076',
      phoneE164: '+18556700076',
      email: 'support@phonelive.io',
      open: false,
      showTeaser: false,
      copied: false,
    }
  },
  computed: {
    smsHref() {
      return 'sms:' + this.phoneE164 + '?&body=' + encodeURIComponent('Hi PhoneLive, I have a question about ')
    },
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown)
    try {
      if (sessionStorage.getItem('pl_support_teaser_dismissed') !== '1') {
        this._teaserTimer = setTimeout(() => { if (!this.open) this.showTeaser = true }, 6000)
      }
    } catch (e) { /* storage blocked — skip the teaser */ }
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown)
    if (this._teaserTimer) clearTimeout(this._teaserTimer)
  },
  methods: {
    // pls_app_track is a global Vue.mixin method (plugins/pls-tracking.js).
    track(name) {
      if (typeof this.pls_app_track === 'function') this.pls_app_track(name)
    },
    openPanel() {
      this.open = true
      this.showTeaser = false
      this.track('support_chat_open')
      this.$nextTick(() => { if (this.$refs.panel && this.$refs.panel.focus) this.$refs.panel.focus() })
    },
    close() { this.open = false },
    toggle() { this.open ? this.close() : this.openPanel() },
    dismissTeaser() {
      this.showTeaser = false
      try { sessionStorage.setItem('pl_support_teaser_dismissed', '1') } catch (e) { /* ignore */ }
    },
    async copyNumber() {
      try {
        await navigator.clipboard.writeText(this.phoneDisplay)
        this.copied = true
        this.track('support_chat_copy_number')
        setTimeout(() => { this.copied = false }, 2000)
      } catch (e) { /* clipboard unavailable — number is still visible to tap/copy */ }
    },
    onKeydown(e) { if (e.key === 'Escape' && this.open) this.close() },
  },
}
